import React from 'react';
import { BadgeWithTooltip } from '../../../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';

type AutoAchievementTooltipProps = {
  id: string;
}

const content = (
  <div>
    When a player selects this answer, they immediately earn this achievement.
  </div>
);

export function AutoAchievementTooltip(props: AutoAchievementTooltipProps) {
  const { id } = props;

  return (
    <div className="position-absolute" style={{ top: '-1em', right: '-1em' }}>
      <BadgeWithTooltip
        id={id}
        title="Auto Achieve Details"
        content={content}
      />
    </div>
  );
}
